import React from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export interface IToastMessageBodyProps {
  titleKey: string;
  message: React.ReactNode;
}

export function ToastMessageBody({
  titleKey,
  message,
}: IToastMessageBodyProps) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        alignItems: 'flex-start',
        textAlign: 'left',
      }}>
      <Typography
        component="div"
        variant="text-md"
        sx={(theme) => ({
          fontWeight: theme.typography.fontWeightBold,
          color: 'text.primary',
        })}>
        {t(titleKey)}
      </Typography>
      <Typography
        component="div"
        variant="text-sm"
        sx={{ color: 'text.secondary' }}>
        {message}
      </Typography>
    </Box>
  );
}
